import React, { Component } from 'react';
import { api_url, headers } from '../../common/config';
import { Link } from 'react-router-dom';

class EducationalCard extends Component {
    constructor(props) {
        super(props);

        this.state = { image: '' };
    }

    componentDidMount() {
        this.getImage();
    }

    getImage = () => {
        if (this.props.image !== undefined) {
            fetch(`${api_url}/autism/files/${this.props.image}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        image: res.data.data.full_url,
                    });
                });
        }
    };
    render() {
        return (
            <Link to={`/blog/educational/${this.props.id}`} replace>
                <div className='educational_card'>
                    <div
                        className='card_image'
                        style={{
                            backgroundImage: `linear-gradient(to bottom,
                                rgba(118, 112, 255, 0) 33%,
                                #7670ff
                            ), url(${this.state.image})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'center',
                        }}
                    ></div>
                    <div className='card_content'>
                        <div className='tag_wrapper'>
                            <p>{this.props.type}</p>
                        </div>
                        <div className='title_wrapper'>
                            <h2>{this.props.title}</h2>
                        </div>
                    </div>
                </div>
            </Link>
        );
    }
}

export default EducationalCard;
